"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContentPostMessageEventCollector = exports.ContainerPostMessageEventCollector = void 0;
const types_1 = require("./types");
class ContainerPostMessageEventCollector extends types_1.EventCollector {
    constructor() {
        super(...arguments);
        this.init = (eventBus) => {
            this.eventBus = eventBus;
        };
    }
}
exports.ContainerPostMessageEventCollector = ContainerPostMessageEventCollector;
class ContentPostMessageEventCollector extends types_1.EventCollector {
    constructor() {
        super(...arguments);
        this.init = (eventBus) => {
            this.eventBus = eventBus;
        };
    }
}
exports.ContentPostMessageEventCollector = ContentPostMessageEventCollector;
//# sourceMappingURL=PostMessages.js.map